import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { selectLoggedIn } from 'services/user/selectors'
import { requireAuth } from 'shared/auth'

export default function (ComposedComponent) {

  class RequireAuthWrapper extends Component {
    static propTypes = {
      isLoggedIn: PropTypes.bool,
      requireAuth: PropTypes.func,
      location: PropTypes.object,
    }

    componentDidMount () {
      const { isLoggedIn, location } = this.props
      if (!isLoggedIn) {
        requireAuth(location)
      }
    }

    render () {
      return (
        <div>
          { this.props.isLoggedIn ? <ComposedComponent {...this.props} /> : null }
        </div>
      )
    }
  }

  const mapStateToProps = (state) => ({
    isLoggedIn: selectLoggedIn(state),
  })

  return connect(mapStateToProps)(RequireAuthWrapper)
}
